import PropTypes from 'prop-types';
import LinkIcon from '@mui/icons-material/Link';
import Portal from '../../portal/Portal';
import CruxClassicModal from '../../common/CruxClassicModal';
import CopyWithTooltip from '../../common/CopyWithTooltip';
import { trackEvent } from '../../../actions/segment';
import Segment from '../../../helpers/Segment';
import SEGMENT from '../../../constants/segment';
import { entryPoints } from '../../../constants/entryPoint';
import RetryReport from '../RetryReport';
import ShareReport from './ShareReport';
import '../../../../css/crux/components/reports/dpprPreviewModal.scss';

// this is a modal component to preview the Digital Property Report (DPPR) or Equity Report Calculator
const CESPreviewModal = (props) => {
    const {
        propertyAddress,
        propertyId,
        cesLink,
        cesLinkExpiry,
        open,
        onClose,
        onRetry,
        dispatch,
        withError,
        entryPoint,
        type,
    } = props;
    const handleEventLogger = (eventName = SEGMENT.EVENT_NAMES.copyReportLink) => {
        const event = eventName === SEGMENT.EVENT_NAMES.copyReportLink ?
            Segment.copyReportLink : Segment.shareReportLink;
        dispatch(trackEvent(event({
            pageContext: SEGMENT.EVENT_PROPERTIES.REPORT_PREVIEW,
            propertyId,
            entryPoint,
            type,
        })));
    };

    return (
        <div id="ces-preview">
            <CruxClassicModal
                title={propertyAddress}
                open={open}
                modalClassName="ces-preview-modal"
                onToggleModal={onClose}
                disableBackdropClick
                bodyWidth="955px"
                bodyHeight="calc(100vh - 206px)"
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'transparent',
                    },
                }}
            >
                {
                    withError ?
                        <RetryReport onClick={onRetry} /> :
                        <Portal src={cesLink} />
                }
                <div className="ces-preview-modal-footer">
                    <CopyWithTooltip
                        forCopy={cesLink}
                        hidden={!cesLink}
                        onCopyEventLogger={handleEventLogger}
                    >
                        <div className="ces-preview-copy-link"><LinkIcon /><span>Copy Link</span></div>
                    </CopyWithTooltip>
                    {
                        cesLink &&
                        <ShareReport
                            cesLink={cesLink}
                            cesLinkExpiry={cesLinkExpiry}
                            propertyAddress={propertyAddress}
                            onClickEventLogger={handleEventLogger}
                            type={type}
                        />
                    }
                </div>
            </CruxClassicModal>
        </div>
    );
};

CESPreviewModal.propTypes = {
    propertyAddress: PropTypes.string,
    propertyId: PropTypes.number,
    cesLink: PropTypes.string,
    cesLinkExpiry: PropTypes.string,
    open: PropTypes.bool,
    withError: PropTypes.bool,
    onClose: PropTypes.func,
    onRetry: PropTypes.func,
    dispatch: PropTypes.func,
    entryPoint: PropTypes.string,
    type: PropTypes.string,
};

CESPreviewModal.defaultProps = {
    entryPoint: entryPoints.REPORTS_MENU,
};

export default CESPreviewModal;
